import React, { useEffect, useMemo } from 'react';
import { useForm, FormProvider } from 'react-hook-form';
import { shallowEqual, useDispatch, useSelector } from 'react-redux';
import {
  fetchUser,
  updateUserSettings,
  fetchAccount
} from '#action/user/settings';
import NotificationChannels from './channels';
import {
  ButtonsContainer,
  NotificationsCnt,
  StyledBtn,
  StyledPaper,
  StyledSubTitle,
  StyledTitle
} from './styles';

const UserNotificationsForm = props => {
  const { history } = props;
  const account = useSelector(s => s.account, shallowEqual);
  const user = useSelector(s => s.user, shallowEqual);
  const dispatch = useDispatch();

  const defaultValues = useMemo(() => ({
    emailMsg: !!user.emailMsg,
    siteMsg: !!user.siteMsg,
    notificationMsg: !!user.notificationMsg,
    smsMsg: false
  }), [user.emailMsg, user.siteMsg, user.notificationMsg]);

  const methods = useForm({
    defaultValues
  });

  const { handleSubmit, reset, formState: { isDirty, isSubmitting } } = methods;

  useEffect(() => {
    reset(defaultValues);
  }, [defaultValues, reset]);

  const handleFormSubmit = async values => {
    try {
      await dispatch(updateUserSettings(user.id, {
        emailMsg: Number(values.emailMsg),
        siteMsg: Number(values.siteMsg),
        notificationMsg: Number(values.notificationMsg)
      }, { successMessage: 'Notification settings were saved successfully!' }));

      await dispatch(fetchUser(user.id));

      if (account.id === user.id) {
        await dispatch(fetchAccount({ ignoreLoading: true }));
      }

      reset({
        ...values,
        smsMsg: false
      }, { keepDirty: false });
    } catch (e) {
      console.error(e);
    }
  };

  return (
    <NotificationsCnt>
      <FormProvider {...methods}>
        <form autoComplete="off" onSubmit={handleSubmit(handleFormSubmit)}>
          <StyledTitle variant="h4" gutterBottom>
            Notifications
          </StyledTitle>
          <StyledPaper elevation={0}>
            <StyledSubTitle variant="subtitle1">
              Notification channels
            </StyledSubTitle>
            <NotificationChannels />
          </StyledPaper>
          <ButtonsContainer>
            <StyledBtn
              variant="outlined"
              onClick={() => {
                history.goBack();
              }}
            >
              Cancel
            </StyledBtn>
            <StyledBtn
              disabled={!isDirty || isSubmitting}
              type="submit"
              variant="contained"
              color="secondary"
            >
              Save
            </StyledBtn>
          </ButtonsContainer>
        </form>
      </FormProvider>
    </NotificationsCnt>
  );
};

export default UserNotificationsForm;
